<template>
  <div class="login-container">
    <span
      v-if="getUserData.token != null && showLabel==true"
      style="text-align: center;font-size: 11px;font-weight: 500;color:#FFFFFF"
    >
      {{ getUserData.nombres }} {{ getUserData.apellidos }}
    </span>
    <Button
      class="p-button-rounded"
      icon="mdi mdi-login-variant"
      :style="{ 'margin-left': '0 .5em' }"
      @click="$router.push({ name: 'login' })"
      v-if="getUserData.token == null"
      v-tooltip="$t('messages.login')"
      name="entrar"
    />
    <Button
      class="p-button-rounded"
      icon="mdi mdi-power"
      :style="{ 'margin-left': '0.5em' }"
      @click="logout()"
      v-if="getUserData.token != null"
      v-tooltip="$t('messages.exit')"
      name="salir"
    />
  </div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex';
export default {
    name:"LoginContainer",
    props: {
        showLabel: {
            type: Boolean,
            default: true
        }
    },
    methods: {
    ...mapMutations(["resetState"]),
    logout() {
      this.resetState();
      this.$router.push({ name: "main" }).catch(() => {});
    }
  },
    computed: {
        ...mapGetters(["getUserData"])
    },
};
</script>

<style scoped>
.login-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction:column-reverse;
  justify-content: center;
  align-items: center;
  padding-right:10px  
}
@media (max-width: 960px) {
  .login-container {    
    padding-right:5px
  }
}
</style>
